import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../utils/forms/forms';
import shippingService from './../../services/shippingProvider';
import store from './../../store';
import QuickProductEdit from './../../components/quickProductEdit/quickProductEdit.vue';
import shippingTransformer from './../../transformers/shippingProvider';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        code: {
          value: '',
          type: 'text',
        },
        
      }),
    };
  },

  props: {
  },

  computed: {
    ...mapGetters({
      shippingProviders: 'allShippingProviders',
    }),

    list() {
      return [];
    },
  },

  watch: { 

    /**
     * Watch product select for autocomplete other fields with defaults.
     */
    'form.name': function () {
     
    },

  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    toFloat(number) {
      return parseFloat(number.replace(/\s/g, '').replace(/,(\d+)$/, '.$1'));
    },

    /**
     * The handler for the quick product edit component that will be passed to the modal.
     *
     * @param  {Object} item The row item.
     * @return {Object}      The component.
     */
    onQuickProductEditMounted() {
      const that = this;
     /* return function () {
        this.$once('close', () => {
          shippingService.all().then(() => {
            const filteredProducts = that.shippingProviders
            .filter(p => p.id.toString() === this.orderProduct.id.toString());
            if (filteredProducts.length) {
              that.form.assignData(this.orderProduct);
              that.form.assignData(filteredProducts[0]);
              that.update(this.orderProduct.id).then(() => {
                that.form.resetValues();
              });
            }
          });
        });
      };*/
    },

    /**
     * Defines the handler for the links one the table.
     *
     * @param  {Object} item The row item.
     * @param  {String} name The field name.
     * @return {Mixed}      False or the handler function in case of a link needed.
     */
    tableClickHandler(item, name) {
      
    },

    /**
     * Saves the form, adding a product.
     */
    save() {
      const data = this.form.data();
      this.form.loading = true;
      const shipping = shippingTransformer.send(
        Object.assign({},this.form.data())
      );
      shippingService.store(shipping)
      .then(() => {
         this.form.loading = false;
          shippingService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        
      });
        /*const self = this;
        console.log(data)
        let product = [];
        if (data.productId) {
          product = this.products
          .filter(p => p.id.toString() === data.productId.toString());
        }

        if(product.length > 0){
           let duplicate = self.currentStockProducts
           .filter(p => p.productId.toString() === data.productId.toString());

           if(duplicate.length <= 0){
             data.product = product[0];
             store.dispatch('PushToStockProducts',data);
           }else{
             this.$message({
              showClose: true,
              customClass: 'error',
              message: 'Product duplicate found',
            });
             return Promise.reject();
           }
        }else{
           this.$message({
            showClose: true,
            customClass: 'error',
            message: 'Product not found',
          });
          return Promise.reject();
        }
       */
        return Promise.all([]);
        /*return new Promise((resolve, reject) => {
        productService.show(data.product_id)
        .then((d) => {
          //console.log(d)
          //console.log(data);
          data.product = d;
          store.dispatch('PushToStockProducts',data);
          resolve();
        }).catch((errors) => {
          console.log(errors);
          reject();
        });
      });*/
    },

    /**
     * Updates a order product.
     */
    update(orderProductId) {
      console.log(orderProductId);
       const data = this.form.data();
      this.form.loading = true;
      const shipping = shippingTransformer.send(
        Object.assign({},this.form.data())
      );
      shippingService.update(orderProductId,shipping)
      .then(() => {
         this.form.loading = false;
          shippingService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        
      });
       return Promise.all([]);
    },

    /**
     * Delete the product from order.
     */
    destroy(orderProductId) {
       shippingService.destroy(orderProductId)
      .then(() => {
         this.form.loading = false;
          shippingService.all();
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
        
      });
    },

    /**
     * Fetch the component's required resources.
     */
    getResources() {
      Promise.all([
        shippingService.all(),
      ]).then(() => {
        this.ready = true;
      });
    },
  },

  mounted() {
    this.getResources();
  },

  components: {
    VFormTable: require('./../formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/shippingProviderTable/shippingProviderTable.js